module.exports = __webpack_public_path__ + "static/media/_DSC6187.0ec27b62.jpg";